<vc-chart-wrapper [title]="title" [contentHeight]="contentHeight" [loading]="loading">
    <div chartActionsRightSide>
        @if (chartActionsTemplate) {
            <ng-container *ngTemplateOutlet="chartActionsTemplate"></ng-container>
        }
        <ng-content select="[chartActionsRightSide]"></ng-content>
    </div>
    @if (!loading) {
        <highcharts-chart
            class="vc-events-findings-chart no-title"
            [options]="chartOptions"
            (chartInstance)="onChartInstance($event)">
        </highcharts-chart>
    }
</vc-chart-wrapper>
